import React, { useState } from 'react'
import { BaseButton } from 'iebt-zing-storybook'
import { Loading } from 'components/loading'
import Tippy from '@tippyjs/react'
import { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'
import 'tippy.js/themes/translucent.css'
import { trans } from 'sharedKernel/i18n'
import { getProvider } from 'sharedKernel/api'
import { triggerFileDownloadOnClientSide } from 'sharedKernel/file/handler'
import { showToast } from 'components/toast'
import { PdfButtonStyled } from './styles'

interface DownloadPdfButtonProps {
  challengeId: string
  solutionId: string
  solutionTitle: string
}

export const DownloadPdfButton: React.FC<DownloadPdfButtonProps> = ({
  challengeId,
  solutionId,
  solutionTitle
}) => {
  const [downloadingPdf, setDownloadingPdf] = useState(false)
  const labels = {
    exportSolutionsPdf: trans('Exportar PDF')
  }
  const { mutate: downloadFile } = getProvider()

  const handleDownload = (): void => {
    setDownloadingPdf(true)
    downloadFile(
      {
        url: `/v1/hub/company/challenge/${challengeId}/solution/${solutionId}/report/analytical/qa/pdf`,
        httpConfig: { responseType: 'blob' }
      },
      {
        onSuccess: (res) => {
          triggerFileDownloadOnClientSide(res.data, `${solutionTitle}.pdf`)
          setDownloadingPdf(false)
        },
        onError: () => {
          showToast('error', 'Ocorreu um erro ao baixar o arquivo. Por favor, tente novamente mais tarde.')
          setDownloadingPdf(false)
        }
      }
    )
  }

  return (
    <Tippy
      content={labels.exportSolutionsPdf}
      followCursor={true}
      plugins={[followCursor]}
      animation="scale"
      arrow={false}
      theme="primary"
    >
      <span>
        <PdfButtonStyled>
          <BaseButton
            btnContent={
              <span>
                {
                  !downloadingPdf
                    ? (
                      <>
                        {labels.exportSolutionsPdf}
                      </>
                      )
                    : (
                      <Loading width="28px" />
                      )
                }
              </span>
            }
            onClick={handleDownload}
            variant="secondary"
          />
        </PdfButtonStyled>
      </span>
    </Tippy>
  )
}
